module.exports = __webpack_public_path__ + "img/square_rotation_af.93dcd557.svg";